const state = {
    renewPopShow: true,
    fiveOpenList: [],
    localShotinfoList: []
}
const mutations = {
    SET_RENEWPOPSHOW: (state, Bln) => {
        state.renewPopShow = Bln
    },
    SET_FIVEOPENLIST: (state, cover) => {
        state.fiveOpenList = cover
    },
    SET_LOCALSHOTINFOLIST: (state, list) => {
        state.groupListData = list
    },
}
export default {
    // 开启命名空间
    namespaced: true,
    mutations,
    state,
}